import SectionHeading from "./SectionHeading";
import { overviewParagraphs, overviewHighlights } from "@/mocks/home";

export default function Overview() {
  return (
    <section id="overview" className="section-anchor bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="THEME OVERVIEW"
          title="题材定位：秘密教学到底在讲什么"
          desc="教学只是外壳，真正被反复打量的是身份距离、边界试探，以及两个人在固定课时里缓慢发生的变化。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-7">
            <div className="space-y-5">
              {overviewParagraphs.map((text) => (
                <p
                  key={text}
                  className="text-sm md:text-base leading-8 text-foreground-700"
                >
                  {text}
                </p>
              ))}
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
              {overviewHighlights.map((item, index) => (
                <div
                  key={item.title}
                  className="rounded-lg border border-background-200 bg-background-100/70 p-4 md:p-5"
                >
                  <div className="flex items-center gap-3">
                    <span className="w-8 h-8 rounded-md flex items-center justify-center bg-secondary-500/15 font-label text-sm font-semibold text-secondary-800">
                      0{index + 1}
                    </span>
                    <h3 className="font-heading text-base font-bold text-foreground-950">
                      {item.title}
                    </h3>
                  </div>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-lg overflow-hidden border border-background-200 bg-background-100">
              <div className="w-full h-64 md:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimal%20abstract%20still%20life%20of%20an%20open%20notebook%2C%20a%20fountain%20pen%20and%20a%20folded%20pair%20of%20wire%20glasses%20resting%20on%20a%20warm%20cream%20tabletop%2C%20soft%20amber%20side%20light%2C%20olive%20green%20and%20terracotta%20accents%2C%20smooth%20background%20gradient%2C%20simplified%20geometric%20shapes%2C%20calm%20academic%20mood%2C%20editorial%20photography%20style&width=900&height=900&seq=secret-teach-overview-02&orientation=squarish"
                  alt="书桌、笔记本与眼镜构成的抽象静物，呼应师生家教题材的安静氛围"
                  className="w-full h-full object-top"
                />
              </div>
              <div className="p-5 md:p-6">
                <h4 className="font-heading text-lg font-bold text-foreground-950">
                  三种阅读方式
                </h4>
                <ul className="mt-4 space-y-3">
                  <li className="flex gap-3 text-sm text-foreground-700">
                    <i className="ri-arrow-right-s-line text-primary-600 mt-0.5" />
                    <span>
                      <strong className="text-foreground-900">按关系看</strong>：
                      先分清家教、私教、补习、辅导四种关系结构。
                    </span>
                  </li>
                  <li className="flex gap-3 text-sm text-foreground-700">
                    <i className="ri-arrow-right-s-line text-primary-600 mt-0.5" />
                    <span>
                      <strong className="text-foreground-900">按空间看</strong>：
                      再用场景筛选定位家中、教室、私域与户外等具体情境。
                    </span>
                  </li>
                  <li className="flex gap-3 text-sm text-foreground-700">
                    <i className="ri-arrow-right-s-line text-primary-600 mt-0.5" />
                    <span>
                      <strong className="text-foreground-900">按时间看</strong>：
                      最后顺着章节脉络，理解关系推进的先后节奏。
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}